module.exports = __webpack_public_path__ + "static/media/Down.b9786df1.webp";